/**
 * QuoteCart — localStorage-backed quote cart.
 * Fires window event 'quotecart:change' on every mutation.
 */
(function (win) {
  'use strict';

  var KEY = 'aat_quote_cart';

  var QuoteCart = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    },

    _save: function (items) {
      try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
      win.dispatchEvent(new CustomEvent('quotecart:change', { detail: { items: items } }));
    },

    add: function (item) {
      var items = this.get();
      item.cartId = String(Date.now()) + Math.random().toString(36).slice(2, 6);
      items.push(item);
      this._save(items);
      return item.cartId;
    },

    update: function (cartId, changes) {
      this._save(this.get().map(function (it) {
        return it.cartId === cartId ? Object.assign({}, it, changes) : it;
      }));
    },

    remove: function (cartId) {
      this._save(this.get().filter(function (it) { return it.cartId !== cartId; }));
    },

    clear: function () { this._save([]); },

    count: function () { return this.get().length; }
  };

  win.QuoteCart = QuoteCart;
})(window);
